import { z } from 'zod';
import { BaseElementSchema } from '@/components/canvas/document/schema/elementBase';
import { TextContentDataSchema, TextStyleOverrideSchema } from '@/components/canvas/elements/text/schema';

export const RectElementSchema = BaseElementSchema.extend({
  type: z.literal('rect'),
  data: z.object({
    text: TextContentDataSchema.optional(),
    textStyle: TextStyleOverrideSchema.partial().optional(),
  }).default({}),
});
